// extracted by mini-css-extract-plugin
export default {"Menu":"AppMenu_Menu__WYQ9N","MenuLink":"AppMenu_MenuLink__yk-pG","ResetBackground":"AppMenu_ResetBackground__x4cMi"};